import React from 'react'
import { Input, Button, Table, Modal } from "antd";
import StyledPeoplePage from "../../../Pages/Settings/People/style";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
// Styled Component Container for all sections
const Customstyle = styled.div`
 text-align:left;
  .acourse-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 20.83px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #1F243B;
  }
  
  .search-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-top: 20px;
    width: 100%;
  }

  .total-course {
    font-size: 16px;
    font-weight: normal;
  }

  .searchbar-style {
    height: 34px;
    width: 210px;
    border-radius: 24px;
    padding: 8px;
  }

  .table-container {
    margin-top: 30px;
  }

  .custom-table {
    width: 100%;
    border-radius: 8px;
  }
  
  .table-row-white {
    background-color: #fff;
  }

  .table-row-gray {
    background-color: #f9f9f9;
  }
  `;
  
function ReportCourse() {
    const columns = [
        {
          title: "Code",
          dataIndex: "code",
          key: "code",
        },
        {
          title: "Course Name",
          dataIndex: "coursename",
          key: "coursename",
        },
        {
          title: "Category",
          dataIndex: "category",
          key: "category",
        },
        {
          title: "Enrolled in",
          dataIndex: "enrolledin",
          key: "enrolledin",
        },
        {
          title: "Completed",
          dataIndex: "completed",
          key: "completed",
        },
        {
          title: "In Progress",
          dataIndex: "inprogress",
          key: "inprogress",
        },
        {
          title: "Not Passed",
          dataIndex: "notpassed",
          key: "notpassed",
        },
      ];
      const data = [
        {
          code: "234",
          coursename: "General Tips to Crack interview",
          category: "Employment",
          enrolledin: "125",
          completed: "110",
          inprogress: "10",
          notpassed: "2",
        },
        {         
          code: "234",
          coursename: "General Tips to Crack interview",
          category: "Employment",
          enrolledin: "125",
          completed: "110",
          inprogress: "10",
          notpassed: "2",
        },
        {          
          code: "234",
          coursename: "General Tips to Crack interview",
          category: "Employment",
          enrolledin: "125",
          completed: "110",
          inprogress: "10",
          notpassed: "2",
        },
        {          
          code: "234",
          coursename: "General Tips to Crack interview",
          category: "Employment",
          enrolledin: "125",
          completed: "110",
          inprogress: "10",
          notpassed: "2",
        },
      ];
  return (
    <div>
        <StyledPeoplePage>
            <Customstyle>
        <p className='acourse-text'>Course Report</p>
        <br/>
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <div>
          Total Course : {data.length}
        </div>
        <div>
              <Input
                placeholder="Search"
                // onChange={handleSearch}
                prefix={<SearchOutlined style={{ color: "#636980",}} />}
                className="searchbar-style"
              />
          </div>
      </div>
          <br/>
          <Table
                      columns={columns}
                      dataSource={data}
                      rowClassName={(record, index) =>
                        index % 2 === 0 ? "table-row-white" : "table-row-gray"
                      }
                      className="custom-table"
                      pagination={false}
                      // onRow={(record, index) => handleRowClick(record)}
                    />
          </Customstyle>
          </StyledPeoplePage>
    </div>
  )
}
export default ReportCourse